













































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import PoweredBy, {PoweredByItem} from '@/components/PoweredBy.vue'
import {GleederHelper} from '@/helpers/GleederHelper'
import {EnvHelper} from '@/helpers/EnvHelper'
import BigNumber from 'bignumber.js'
import MyWalletGetGasTokenToUse from '@/components/myWallet/MyWalletGetGasTokenToUse.vue'
import MyWalletGetGasTokenToReceive from '@/components/myWallet/MyWalletGetGasTokenToReceive.vue'
import {MyWalletCacheAssist} from '@/helpers/MyWalletCacheAssist'
import TooltipMobileContent from '@/components/tooltip/TooltipMobileContent.vue'
import MyWalletProceedButton from '@/components/myWallet/MyWalletProceedButton.vue'
import MyWalletDisclaimerMobile from '@/components/myWallet/MyWalletDisclaimerMobile.vue'
import {$} from '@/facade'

@Component({
  components: {
    MyWalletDisclaimerMobile,
    MyWalletProceedButton,
    TooltipMobileContent,
    MyWalletGetGasTokenToReceive,
    MyWalletGetGasTokenToUse,
    PoweredBy,
  },
})
export default class MyWalletGetGasSection extends Vue {
  @Prop({type: MyWalletCacheAssist, required: true})
  cacheAssist!: MyWalletCacheAssist

  poweredByList = [
    {
      url: 'https://https://gleeder.app//',
      alt: 'Gleeder icon',
      filename: 'gleeder-icon.svg',
    } as PoweredByItem,
  ]

  neoOwned: string = this.toFixedOrZero(null)
  amountToReceive: string = this.toFixedOrEmpty(null)
  amountToUse: string = this.toFixedOrZero(null)

  gasOut: number = 0

  openMobileDisclaimer = false

  get popoverText() {
    if (this.temporarilyUnavailable) {
      return $.translate(
        'components.MyWalletGetGasSection.temporarilyUnavailable'
      )
    }

    if (this.cacheAssist.currentWallet.isWatchWallet) {
      return $.translate(
        'components.MyWalletGetGasSection.watchWalletDisclaimer'
      )
    }

    return $.translate('components.MyWalletGetGasSection.unavailableDisclaimer')
  }

  get temporarilyUnavailable() {
    return true
  }

  get isSwapButtonDisabled() {
    if (
      this.cacheAssist.currentWallet.isWatchWallet ||
      this.temporarilyUnavailable
    ) {
      return true
    }

    return (
      !this.amountToUse.trim() ||
      this.amountToUse.trim() === '0' ||
      new BigNumber(this.amountToUse).gt(new BigNumber(this.neoOwned!))
    )
  }

  async mounted() {
    await this.populateGasOut()
  }

  async populateGasOut() {
    const response = await GleederHelper.getAmountsOutFlamingo({
      amountIn: '1',
      decimalsTokenToUse: EnvHelper.VUE_APP_BNEO_DECIMALS,
      hashTokenToUse: EnvHelper.VUE_APP_BNEO_SCRIPT_HASH,
      hashTokenToReceive: GleederHelper.gasScriptHash,
    })

    this.gasOut = Number(
      (response.stack[0].value as {type: string; value: string}[])[1].value
    )
  }

  async onClickSwap() {
    if (!this.amountToReceive || !this.amountToUse) {
      return
    }

    await $.walletAdapter.executeWithConnectedN3Wallet(() => {
      $.modal.open('getGasModal', {
        amountToReceive: this.amountToReceive,
        amountToUse: this.amountToUse,
      })
    })
  }

  setOpenMobileDisclaimer(val: boolean) {
    this.openMobileDisclaimer = val
  }

  handleAmountToUseInput(val: string) {
    this.amountToUse = val

    if (!this.amountToUse || Number(this.amountToUse) === 0) {
      this.setAmountToReceive(null)
      return
    }

    this.amountToReceive = BigNumber(this.gasOut)
      .multipliedBy(this.amountToUse)
      .shiftedBy(-EnvHelper.VUE_APP_BNEO_DECIMALS) // Decimals fixed back
      .minus(0.5) // Business rule: we'll display for the user is always 0.5 less the value we received from RPC
      .toString()
  }

  @Watch('cacheAssist.neoBalance')
  async onNeoBalanceChange() {
    this.neoOwned = String(this.cacheAssist.neoBalance)
  }

  private setAmountToReceive(
    val: string | null,
    shouldSetAmountToUse: boolean = true
  ) {
    this.amountToReceive = this.toFixedOrEmpty(val)

    if (!shouldSetAmountToUse) return

    if (!val) {
      this.setAmountToUse(null, false)
      return
    }
  }

  private toFixedOrEmpty(val: string | null) {
    if (!val) return ''

    return val.length === 0 ? '' : new BigNumber(val).toFixed()
  }

  private toFixedOrZero(val: string | null) {
    if (!val) return '0'

    return val.length === 0 ? '0' : new BigNumber(val).toFixed()
  }

  private setAmountToUse(
    val: string | null,
    shouldSetAmountToReceive: boolean = true
  ) {
    this.amountToUse = this.toFixedOrZero(val)

    if (!shouldSetAmountToReceive) return

    if (!val) {
      this.setAmountToReceive(null, false)
      return
    }
  }
}
